import { render, staticRenderFns } from "./GroupMaterial.vue?vue&type=template&id=4719d2c2"
import script from "./GroupMaterial.vue?vue&type=script&lang=js"
export * from "./GroupMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports